export enum MomentTimeZoneEnum {
  HIGHMARK = 'America/New_York',
  WYOMING = 'America/Denver',
  MINNESOTA = 'America/Chicago',
  NORTH_DAKOTA = 'America/Chicago'
}
